import { render } from "./GlobalPrescriptionNotes.vue?vue&type=template&id=1b281046&scoped=true"
import script from "./GlobalPrescriptionNotes.vue?vue&type=script&lang=js"
export * from "./GlobalPrescriptionNotes.vue?vue&type=script&lang=js"

import "./GlobalPrescriptionNotes.vue?vue&type=style&index=0&id=1b281046&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b281046"]])

export default __exports__